<template>
  <div class="combo-list">
    <Navbar title="会员购买列表"></Navbar>
    <van-search
      v-model="listQuery.phone"
      type="number"
      placeholder="输入手机号查询订单"
      show-action
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <div class="combo">
      <div class="item" v-for="(item, index) in comboList" :key="index">
        <div class="activity-name">
          <van-cell
            :title="item.name"
            is-link
            :to="{ path: 'comboDetail', query: { id: item.id } }"
          />
        </div>
        <van-row type="flex" class="user-info" justify="space-between">
          <van-col class="phone">{{ item.userPhone }}</van-col>
        </van-row>
        <van-row type="flex" class="order-info" justify="space-between">
          <van-col>开通时间:{{ item.createAt }}</van-col>
          <van-col>过期时间:{{ item.validTime }}</van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { comboList } from "@/api/combo";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      listQuery: {
        phone: ""
      },
      comboList: []
    };
  },
  mounted() {
    this.handleComboList();
  },
  methods: {
    // 搜索
    onSearch() {
      this.handleComboList();
    },
    // 套餐列表
    handleComboList() {
      comboList(this.listQuery).then(res => {
        // console.log("套餐列表:", res);
        this.comboList = res.rows;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.combo-list {
  overflow: hidden;

  .combo {
    padding: 10px;

    .item {
      padding: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      background-color: #f6f7f9;

      .activity-name {
        .van-cell {
          padding: 10px 0;
          padding-top: 0;
          text-align: left;
          background-color: #f6f7f9;
        }
      }

      .user-info {
        padding-bottom: 5px;
        border-bottom: 1px solid #f6f7f9;

        .phone {
          color: blue;
        }
      }

      .order-info {
        padding-top: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
<style lang="scss">
.combo-list {
  .van-search__content {
    border-radius: 50px;
  }
}
</style>
